import request from '@/api/request'
export default {
    loginByCode(params) {
        return request({
            url: '/login/user/phone',
            method: 'post',
            params: params
        })
    },

    // ========== 系统参数管理 ==========
    // 获取系统参数
    getSystemParams() {
        return request({
            url: '/system/get',
            method: 'get'
        })
    },

    // 更新系统参数
    updateSystemParams(data) {
        return request({
            url: '/system/update',
            method: 'post',
            data
        })
    },

    // 上传客户端APP安装包（文件可能较大，增加超时时间）
    uploadApp(data) {
        return request({
            url: '/system/uploadApp',
            method: 'post',
            data,
            timeout: 30000 // 5 分钟，避免上传被默认 5 秒超时中断
            // 不手动设置 Content-Type，让 axios 自动处理 multipart/form-data 和 boundary
        })
    },

    // ========== 用户使用记录管理 ==========
    // 分页查询使用记录
    getUsageLogList(params) {
        return request({
            url: '/usageLog/list',
            method: 'get',
            params
        })
    },

    // 获取用户使用统计
    getUsageLogStatistics(params) {
        return request({
            url: '/usageLog/statistics',
            method: 'get',
            params
        })
    },

    // ========== 语言响应格式配置管理 ==========
    // 获取所有语言响应格式配置
    getAllLanguageResponseFormats() {
        return request({
            url: '/systemPrompt/getAll',
            method: 'get'
        })
    },

    // 添加语言响应格式配置
    addLanguageResponseFormat(data) {
        return request({
            url: '/systemPrompt/add',
            method: 'post',
            data
        })
    },

    // 修改语言响应格式配置
    updateLanguageResponseFormat(data) {
        return request({
            url: '/systemPrompt/update',
            method: 'post',
            data
        })
    },

    // ========== Qwen 配置管理 ==========
    // 获取Qwen配置列表
    getConfigs() {
        return request({
            url: '/system/getConfigs',
            method: 'get'
        })
    },

    // 更新Qwen配置
    updateConfigs(data) {
        return request({
            url: '/system/updateConfigs',
            method: 'post',
            data
        })
    },

    // 单独更新单个Qwen配置
    updateConfig(data) {
        return request({
            url: '/system/updateConfig',
            method: 'post',
            data
        })
    },

    // ========== 时长套餐（管理员） ==========
    listTimePlans() {
        return request({
            url: '/admin/timePlan/list',
            method: 'get'
        })
    },
    getTimePlan(id) {
        return request({
            url: '/admin/timePlan/get',
            method: 'get',
            params: { id }
        })
    },
    addTimePlan(data) {
        return request({
            url: '/admin/timePlan/add',
            method: 'post',
            data
        })
    },
    updateTimePlan(data) {
        return request({
            url: '/admin/timePlan/update',
            method: 'post',
            data
        })
    },
    deleteTimePlan(id) {
        return request({
            url: '/admin/timePlan/delete',
            method: 'post',
            params: { id }
        })
    },

    // ========== Prompt 模板库（管理员） ==========
    listPromptTemplates(params) {
        return request({
            url: '/admin/prompt/list',
            method: 'get',
            params: params || {}
        })
    },
    getPromptTemplate(id) {
        return request({
            url: '/admin/prompt/get',
            method: 'get',
            params: { id }
        })
    },
    addPromptTemplate(data) {
        return request({
            url: '/admin/prompt/add',
            method: 'post',
            data
        })
    },
    updatePromptTemplate(data) {
        return request({
            url: '/admin/prompt/update',
            method: 'post',
            data
        })
    },
    deletePromptTemplate(id) {
        return request({
            url: '/admin/prompt/delete',
            method: 'post',
            params: { id }
        })
    },

    // ========== 行为规则（管理员） ==========
    listBehaviorRules(params) {
        return request({
            url: '/admin/behaviorRule/list',
            method: 'get',
            params: params || {}
        })
    },
    getBehaviorRule(id) {
        return request({
            url: '/admin/behaviorRule/get',
            method: 'get',
            params: { id }
        })
    },
    addBehaviorRule(data) {
        return request({
            url: '/admin/behaviorRule/add',
            method: 'post',
            data
        })
    },
    updateBehaviorRule(data) {
        return request({
            url: '/admin/behaviorRule/update',
            method: 'post',
            data
        })
    },
    deleteBehaviorRule(id) {
        return request({
            url: '/admin/behaviorRule/delete',
            method: 'post',
            params: { id }
        })
    },

    // ========== 用量套餐 / 等级（管理员，仅列表与编辑） ==========
    listPlans() {
        return request({
            url: '/admin/plan/list',
            method: 'get'
        })
    },
    getPlan(id) {
        return request({
            url: '/admin/plan/get',
            method: 'get',
            params: { id }
        })
    },
    updatePlan(data) {
        return request({
            url: '/admin/plan/update',
            method: 'post',
            data
        })
    },

    // ========== 设备信息（管理员） ==========
    listDeviceInfo(params) {
        return request({
            url: '/admin/deviceInfo/list',
            method: 'get',
            params: params || {}
        })
    },
    getDeviceInfo(id) {
        return request({
            url: '/admin/deviceInfo/get',
            method: 'get',
            params: { id }
        })
    },
    addDeviceInfo(data) {
        return request({
            url: '/admin/deviceInfo/add',
            method: 'post',
            data
        })
    },
    updateDeviceInfo(data) {
        return request({
            url: '/admin/deviceInfo/update',
            method: 'post',
            data
        })
    },
    deleteDeviceInfo(id) {
        return request({
            url: '/admin/deviceInfo/delete',
            method: 'post',
            params: { id }
        })
    },

    // ========== 平台用户（管理员） ==========
    listUsersAdmin(params) {
        return request({
            url: '/admin/user/list',
            method: 'get',
            params: params || {}
        })
    },
    rechargeUserTime(data) {
        return request({
            url: '/admin/user/rechargeTime',
            method: 'post',
            data
        })
    },

    // ========== 平台订单（plan_orders，管理员） ==========
    listOrdersAdmin(params) {
        return request({
            url: '/admin/order/list',
            method: 'get',
            params: params || {}
        })
    },

    // ========== 激活码（管理员） ==========
    generateActivationCode(data) {
        return request({
            url: '/admin/activationCode/generate',
            method: 'post',
            data
        })
    },
    listActivationCodes(params) {
        return request({
            url: '/admin/activationCode/list',
            method: 'get',
            params: params || {}
        })
    },
    revokeActivationCode(id) {
        return request({
            url: '/admin/activationCode/revoke',
            method: 'post',
            params: { id }
        })
    }
}
